import React, { useState, useEffect } from 'react';
import WalletConnect from './components/WalletConnect';
import BridgeForm from './components/BridgeForm';
import TransactionStatus from './components/TransactionStatus';
import './App.css';
import API_CONFIG from './config/api';

function App() {
  const [account, setAccount] = useState(null);
  const [walletType, setWalletType] = useState(null);
  const [chains, setChains] = useState([]);
  const [transaction, setTransaction] = useState(null);


  useEffect(() => {
    fetchChains();
  }, []);

  const fetchChains = async () => {
    try {
      const response = await fetch(`${API_CONFIG.BASE_URL}/api/chains`);
      const data = await response.json();
      setChains(data);
    } catch (error) {
      console.error('Failed to fetch chains:', error);
    }
  };

  const handleWalletConnect = (account, type) => {
    setAccount(account);
    setWalletType(type);
  };

  const handleDisconnect = () => {
    setAccount(null);
    setWalletType(null);
    setTransaction(null);
  };

  const handleTransactionSubmit = (txData) => {
    setTransaction(txData);
  };

  return (
    <div className="App">
      <div className="container">
        <header className="header">
          <h1>Cross-Chain Bridge</h1>
          <p>Powered by LayerZero</p>
        </header>

        <div className="bridge-container">
          {!account ? (
            <WalletConnect onConnect={handleWalletConnect} />
          ) : (
            <div className="connected-section">
              <div className="wallet-info">
                <span className="wallet-address">
                  {account.slice(0, 6)}...{account.slice(-4)}
                </span>
                <span className="wallet-type">({walletType})</span>
                <button onClick={handleDisconnect} className="disconnect-btn">
                  Disconnect
                </button>
              </div>


              <BridgeForm
                chains={chains}
                account={account}
                walletType={walletType}
                onTransactionSubmit={handleTransactionSubmit}
              />

              {transaction && (
                <TransactionStatus transaction={transaction} />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;